import { render, staticRenderFns } from "./UserManagementAdd.vue?vue&type=template&id=d99b98b6"
import script from "./UserManagementAdd.vue?vue&type=script&lang=js"
export * from "./UserManagementAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports